import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { debouncedFunction } from "../utils/helper";
import { UserLoginData } from "../components/common/charts/Enums";
import { setIsLoading } from "../redux/actions/commanAction";
import { defaultPageNo, defaultPageSize, URLS } from "../constants/constants";
import apiHelper from "../utils/apiHelper";
import { tr } from "date-fns/locale";

export const infiniteScrollHook = ({
  httpFetchDataFn,
  parentEntityId = null,
  isDependentEntity = false,
  FullyQualifiedFilters = null,
  FullyQualifiedSorts = null,
  filterEntityTypeId = undefined,
  filterEntityIds = undefined,
  dateFilterDateFilterTypeId = undefined,
  dateFilterClientDate = undefined,
  dateFilterStartDate = undefined,
  dateFilterEndDate = undefined,
  dateFilterDateField = undefined,
  pageSize = undefined,
  skipAutoFetch = false,
  // Platform-portal support: an explicit reqId (e.g. the selected organization id) that takes
  // precedence over the session-derived org/tenant/contractor id. Pass this when the caller has no
  // organization_id in sessionStorage (Platform super-admin) but still needs an org-scoped list.
  overrideReqId = undefined,
}) => {
  const dispatch: any = useDispatch();
  const orgId = parseInt(sessionStorage.getItem(UserLoginData.organization_id));
  const tenantId = parseInt(sessionStorage.getItem(UserLoginData.tenant_id)) || JSON.parse(sessionStorage.getItem("tenantInfo") || "{}").tenantId;
  const contractorInfo = JSON.parse(sessionStorage.getItem("contractorInfo") || "{}");
  const contractorId = Number(contractorInfo?.id ?? contractorInfo?.contractorId ?? sessionStorage.getItem("contractorId") ?? 0);
  const fallbackId = tenantId || contractorId;
  const reqID = (overrideReqId !== undefined && overrideReqId !== null)
    ? overrideReqId
    : orgId ? isDependentEntity ? parentEntityId : orgId : isDependentEntity ? parentEntityId : fallbackId;
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  const [hasMore, setHasMore] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSortDirection, setCurrentSortDirection] = useState("asc");

  const [distinctFilterValues, setDistinctFilterValues] = useState<any>([]);
  const [aggregateValues, setAggregateValues] = useState<any>();
  const [formattedAggregateValues, setFormattedAggregateValues] = useState<any>();
  const [calculateValue, setcalculateValue] = useState<any>();
  const fetchIdRef = useRef(0);
  const httpFetchDataFnRef = useRef(httpFetchDataFn);
  httpFetchDataFnRef.current = httpFetchDataFn;

  const handleSort = () => {
    const newSortDirection = currentSortDirection === "asc" ? "desc" : "asc";
    setCurrentSortDirection(newSortDirection);
  };

  const concateOldRecords = (oldRecords = []) => {
    return [...oldRecords];
  };

  const fetchData = (page) => {
    var currPage = isNaN(page) ? currentPage : page;
    const fetchId = ++fetchIdRef.current;

    if (reqID) {
      setLoading(true);
      if (currPage === 1) {
        setRows([]);
      }
      dispatch(setIsLoading(true));
      apiHelper(
        httpFetchDataFnRef.current,
        { showNotification: false },
        reqID,
        defaultPageSize,
        currPage,
        undefined,
        filterEntityTypeId,
        filterEntityIds,
        FullyQualifiedFilters,
        FullyQualifiedSorts,
        dateFilterDateFilterTypeId,
        dateFilterClientDate,
        dateFilterStartDate,
        dateFilterEndDate,
        dateFilterDateField,
        undefined,
        undefined
      )
        .then(({ data }) => {
          if (fetchId !== fetchIdRef.current) return;

          setLoading(false);
          if (distinctFilterValues.length == 0) {
            setDistinctFilterValues(data?.distinctFilterValues);
          }
          setAggregateValues(data?.aggregateValues);
          setFormattedAggregateValues(data?.formattedAggregateValues);
          setcalculateValue(data?.formattedCalculatedValues);
          setCurrentPage(currPage);
          dispatch(setIsLoading(false));
          setRowCount(data?.recordCount ?? 0);
          const records = data?.success ?? [];
          if (currPage === 1) {
            setRows([...records]);
          } else {
            setRows((prevRows) => [
              ...concateOldRecords(prevRows),
              ...records,
            ]);
          }

          setHasMore((data?.recordCount ?? 0) > currPage * defaultPageSize);
        })
        .catch((e) => {
          if (fetchId !== fetchIdRef.current) return;

          setLoading(false);
          dispatch(setIsLoading(false));
          setRowCount(0);
          setRows([]);
          setHasMore(false);
        });
    } else
      console.log("No dependent information provided to fetch the records!");
  };

  useEffect(() => {
    if (skipAutoFetch) return;
    debouncedFunction(() => fetchData(1), 500)();
  }, [FullyQualifiedFilters, FullyQualifiedSorts, currentSortDirection, skipAutoFetch, overrideReqId]);

  return {
    loading,
    rows,
    rowCount,
    hasMore,
    distinctFilterValues,
    aggregateValues,
    formattedAggregateValues,
    calculateValue,
    fetchData,
    handleSort,
    currentSortDirection,
    currentPage
  };
};